import { render } from "./CarcassModal.vue?vue&type=template&id=0dd79f08"
import script from "./CarcassModal.vue?vue&type=script&lang=js"
export * from "./CarcassModal.vue?vue&type=script&lang=js"

import "./CarcassModal.vue?vue&type=style&index=0&id=0dd79f08&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__